import type { ApolloError } from '@apollo/client';
import { useEffect } from 'react';

import type { Company } from '@xing-com/crate-common-graphql-types';

import { MAX_LOGGED_OUT_ITEMS } from '../../config';
import { useCompanyData } from '../../hooks/use-company-data/use-company-data';
import { CompanyCard } from '../company-card';
import { CompanyCardContainer } from '../company-card-container';
import { PageError } from '../page-error';
import { Pagination } from '../pagination';

import * as Styled from './company-loggedout.styles';

const CompanyLoggedout = ({
  companies,
  total,
  authenticated,
  limit,
  activePage,
  changePage,
  error,
}: {
  companies: Company[] | undefined;
  total: number | undefined;
  authenticated: boolean;
  limit: number;
  activePage: number;
  changePage: any;
  error: ApolloError | undefined;
}) => {
  const addCompanies = useCompanyData(({ addCompanies }) => addCompanies);
  const globalCompaniesState = useCompanyData(
    ({ globalCompaniesState }) => globalCompaniesState
  );
  useEffect(() => {
    if (companies) {
      addCompanies({
        companies,
      });
    }
  }, [companies]);

  if (error) return <PageError />;
  return (
    <>
      <CompanyCardContainer>
        {companies?.map((company, index) => {
          const isFollowing =
            company?.userContext?.followState?.isFollowing || false;

          return (
            <CompanyCard
              key={company?.id}
              company={company}
              buttons={
                authenticated && globalCompaniesState.length > 0
                  ? [
                      <Styled.FollowButton
                        disabled={company?.entityPageId ? false : true}
                        entityPageId={company?.entityPageId || ''}
                        key={company?.entityPageId}
                        isFollowing={isFollowing}
                        companyId={company?.id}
                        position={index}
                      />,
                    ]
                  : []
              }
            />
          );
        })}
      </CompanyCardContainer>
      {companies && (
        <Pagination
          currentPage={activePage}
          perPage={limit}
          total={Math.min(MAX_LOGGED_OUT_ITEMS, total as number)}
          onPageClick={changePage}
        />
      )}
    </>
  );
};

export { CompanyLoggedout };
